import { render, staticRenderFns } from "./dynPlaceholder.vue?vue&type=template&id=c9102c1a&"
import script from "./dynPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./dynPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./dynPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports